export default "__VITE_ASSET__CPUsSaWs__"